import IconButton from '@/global/components/Button/IconButton'
import { GridRenderCellParams } from '@/global/components/DataGrid/utils/types'
import Dialog from '@/global/guides/Dialog'
import { Trash2Icon } from 'lucide-react'
import { queryClient } from 'providers/ReactQuery'
import { useMemo, useState } from 'react'
import { local } from 'service/api'
import { toast } from 'sonner'

export function DesassociarFuncionarioLocal(props: GridRenderCellParams) {
    const MemoizedModal = useMemo(() => {
        return <Modal {...props} />
    }, [props.row.id])

    return MemoizedModal
}

function Modal({ row }: GridRenderCellParams) {
    const [open, setOpen] = useState(false)
    const { mutateAsync } = local.funcionarios.mutations.useDelete({
        onSuccess: async () => {
            toast.success('Funcionário desassociado com sucesso')
            await queryClient.invalidateQueries(['local', row.localId])
        },
        onError: () => {
            toast.error('Erro ao desassociar funcionário')
        },
    })

    function handleSubmit() {
        return mutateAsync(row.id)
    }

    return [
        <IconButton
            onClick={() => setOpen(true)}
            key="botao"
            title="Desassociar"
        >
            <Trash2Icon className="text-error" />
        </IconButton>,
        <Dialog.Root
            key="modal"
            open={open}
            onClose={() => setOpen(false)}
            width="fit"
            onSubmit={handleSubmit}
        >
            <Dialog.Title wrap>
                Deseja desassociar o funcionário deste local?
            </Dialog.Title>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit>
                    Confirmar
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>,
    ]
}
